var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccessDenied(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-accessDenied_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "accessDenied_1",
    "data-name": "accessDenied \\u2013 1",
    clipPath: "url(#clip-accessDenied_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14566",
    "data-name": "Group 14566",
    transform: "translate(20619 18900)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4836",
    "data-name": "Rectangle 4836",
    width: 256,
    height: 256,
    transform: "translate(-20619 -18900)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14463",
    "data-name": "Group 14463",
    transform: "translate(-451.421 -35.824)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1079",
    "data-name": "Ellipse 1079",
    cx: 102.469,
    cy: 102.469,
    r: 102.469,
    transform: "translate(-20139.938 -18835.545)",
    fill: "#a7dbe7",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1078",
    "data-name": "Ellipse 1078",
    cx: 89,
    cy: 89,
    r: 89,
    transform: "translate(-20126.469 -18822.076)",
    fill: "rgba(36,164,196,0.2)",
    opacity: 0.54
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14351",
    "data-name": "Group 14351",
    transform: "translate(-20088.799 -19023.604)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22426",
    "data-name": "Path 22426",
    d: "M123.069,238.866l-1.675-1.675-1.664,1.661-1.356-1.357,1.664-1.661-1.664-1.664,1.356-1.357,1.664,1.664,1.661-1.664,1.357,1.357-1.661,1.664,1.675,1.675Zm-1.675-2.127,1.675,1.675.9-.905-1.675-1.674,1.661-1.664-.9-.9-1.661,1.664-1.664-1.664-.9.9,1.664,1.664-1.664,1.661.9.9Z",
    transform: "translate(0 0)",
    fill: "#0e424e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_24868",
    "data-name": "Path 24868",
    d: "M84.65,238.609a4,4,0,1,1-4,4A4,4,0,0,1,84.65,238.609Zm2.506,4a2.5,2.5,0,1,0-2.506,2.506A2.505,2.505,0,0,0,87.156,242.605Z",
    transform: "matrix(-0.934, 0.358, -0.358, -0.934, -19974.441, -18541.102)",
    fill: "#3aadca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25033",
    "data-name": "Path 25033",
    d: "M83.169,238.609a2.516,2.516,0,1,1-2.515,2.515A2.518,2.518,0,0,1,83.169,238.609Zm1.577,2.515a1.576,1.576,0,1,0-1.577,1.577A1.577,1.577,0,0,0,84.746,241.124Z",
    transform: "matrix(-0.934, 0.358, -0.358, -0.934, -19973.49, -18534.484)",
    fill: "#3aadca"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14458",
    "data-name": "Group 14458",
    transform: "translate(237.981 47.914)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25018",
    "data-name": "Path 25018",
    d: "M65.316,15.495,37.813,3.271a3.056,3.056,0,0,0-2.506,0L7.8,15.495A3.056,3.056,0,0,0,6,18.276V44.435a26.556,26.556,0,0,0,8.893,19.68l19.65,17.45a3.056,3.056,0,0,0,4.034,0l19.65-17.45a26.556,26.556,0,0,0,8.893-19.68V18.276A3.056,3.056,0,0,0,65.316,15.495Zm-4.309,28.94a20.383,20.383,0,0,1-6.845,15.28L36.56,75.3l-17.6-15.647a20.383,20.383,0,0,1-6.845-15.28V20.262L36.56,9.383,61.008,20.262Z",
    transform: "translate(-20312.01 -18823.652)",
    fill: "#24a4c4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1439",
    transform: "translate(-20290.109 -18798.77)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1433",
    d: "M16.663,292.65a14.663,14.663,0,1,0,14.663,14.663A14.685,14.685,0,0,0,16.663,292.65Zm0,2.932a11.679,11.679,0,0,1,7.191,2.469L7.4,314.506a11.729,11.729,0,0,1,9.264-18.924Zm9.267,4.539A11.73,11.73,0,0,1,9.472,316.58Z",
    transform: "translate(-2 -292.65)",
    fill: "#1d839d"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_25025",
    "data-name": "Path 25025",
    d: "M952.654,673.064s-.614,6.051-5.389,6.47c4.775.418,5.389,6.47,5.389,6.47s.614-6.052,5.389-6.47c-4.775-.419-5.389-6.47-5.389-6.47",
    transform: "translate(-20893.734 -19440.797)",
    fill: "#a7dbe7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25031",
    "data-name": "Path 25031",
    d: "M952.654,673.064s-.614,6.051-5.389,6.47c4.775.418,5.389,6.47,5.389,6.47s.614-6.052,5.389-6.47c-4.775-.419-5.389-6.47-5.389-6.47",
    transform: "translate(-20970.734 -19316.611)",
    fill: "#a7dbe7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25030",
    "data-name": "Path 25030",
    d: "M952.654,673.064s-.614,6.051-5.389,6.47c4.775.418,5.389,6.47,5.389,6.47s.614-6.052,5.389-6.47c-4.775-.419-5.389-6.47-5.389-6.47",
    transform: "translate(-21026.611 -19495.141)",
    fill: "#a7dbe7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25026",
    "data-name": "Path 25026",
    d: "M950.378,673.064s-.354,3.5-3.113,3.738c2.758.242,3.113,3.737,3.113,3.737s.355-3.5,3.113-3.737c-2.759-.242-3.113-3.738-3.113-3.738",
    transform: "translate(-20886.07 -19441.801)",
    fill: "#a7dbe7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25032",
    "data-name": "Path 25032",
    d: "M950.378,673.064s-.354,3.5-3.113,3.738c2.758.242,3.113,3.737,3.113,3.737s.355-3.5,3.113-3.737c-2.759-.242-3.113-3.738-3.113-3.738",
    transform: "translate(-20963.07 -19317.615)",
    fill: "#a7dbe7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14459",
    "data-name": "Group 14459",
    transform: "translate(-20141.711 -18810.105)",
    opacity: 0.531
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23178",
    "data-name": "Path 23178",
    d: "M97.995,98.817h22.3a4.736,4.736,0,1,0,0-9.47,4.915,4.915,0,0,0-2.658.774,4.7,4.7,0,0,0-7.8-4.579,3.843,3.843,0,1,0-7.275,2.339q-.116-.008-.233-.008a3.437,3.437,0,0,0-3.287,4.434,3.338,3.338,0,1,0-1.041,6.51Z",
    transform: "translate(-94.657 -82.478)",
    fill: "#7cc8dc",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14460",
    "data-name": "Group 14460",
    transform: "translate(-20000.469 -18832.469)",
    opacity: 0.531
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23178-2",
    "data-name": "Path 23178",
    d: "M96.78,92.871h14.183a3.013,3.013,0,1,0,0-6.024,3.127,3.127,0,0,0-1.691.492,2.987,2.987,0,0,0-4.963-2.913,2.444,2.444,0,1,0-4.628,1.488q-.074,0-.149,0a2.186,2.186,0,0,0-2.091,2.821,2.123,2.123,0,1,0-.662,4.141Z",
    transform: "translate(-94.657 -82.478)",
    fill: "#7cc8dc",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14462",
    "data-name": "Group 14462",
    transform: "translate(-20213.428 -18896.537)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22426-2",
    "data-name": "Path 22426",
    d: "M123.3,239.159l-1.756-1.756-1.745,1.742-1.422-1.422,1.744-1.742-1.744-1.745,1.422-1.422,1.745,1.745,1.742-1.745,1.422,1.422-1.742,1.745,1.756,1.756Zm-1.756-2.23,1.756,1.756.949-.949-1.756-1.756,1.742-1.745-.949-.949-1.742,1.745-1.745-1.745-.948.949,1.744,1.745-1.744,1.742.948.949Z",
    transform: "translate(0 0)",
    fill: "#166276"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_25028",
    "data-name": "Path 25028",
    d: "M83.424,238.609a2.771,2.771,0,1,1-2.77,2.77A2.773,2.773,0,0,1,83.424,238.609Zm1.737,2.77a1.736,1.736,0,1,0-1.737,1.737A1.737,1.737,0,0,0,85.161,241.379Z",
    transform: "translate(-20119.764 -18906.861)",
    fill: "#3aadca"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessDenied);
export default __webpack_public_path__ + "static/media/accessDenied.171065748eaddb776c24dcf0f466b041.svg";
export { ForwardRef as ReactComponent };